var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI1CampingCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 26H52v28h3.52a7 7 0 1114 0H76V44L63 26zm-6 11v-7h3l5 7h-8zm9.46 17v.37a4 4 0 11-8 0V54a4 4 0 017.92 0h.08zm-3-31a2.509 2.509 0 001.83-.9A3.24 3.24 0 0066 20a2.84 2.84 0 00-2.58-3H37l-10.67 8H8v29h5.69a7 7 0 1114 0H49V23H63.46zM29 38H14v-8h15v8zm14 11h-8V30h8v19zm-18.37 5v.37a4 4 0 11-8 0V54a4 4 0 017.93 0h.07zM23 21H5a1 1 0 00-1 1v17H0V22a5 5 0 015-5h18v4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/I1_Camping_car.2292837d.svg";
export { SvgI1CampingCar as ReactComponent };